/* eslint-disable react-hooks/exhaustive-deps */
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useCallback, useEffect, useRef, useState } from "react";
import SignaturePadComponent, {
  SignaturePadRef,
} from "../Add Risk Assessment/SignaturePadComponent";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import {
  convertDateToEpoch,
  convertDateToEpochUTC,
} from "../../../../helper/DateConverters";
import { dataURLToFile, getTodayDate } from "../helper/helperFunctions";
import { fetchUsersList } from "../Job Sheet Gloucester/fetchData";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
import { fetchAmelioID, fetchVehiclesList } from "./fetchData";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { useNavigate } from "react-router-dom";
import axios from "../../../../util/axiosconfig";
import PhotoUpload from "../Job Sheet Belfast/photoUpload";

const JobsheetGloucesterForm = () => {
  const toast = useRef<Toast>(null);

  const navigate = useNavigate();

  const [isUploadInProgress, setIsUploadInProgress] = useState(false);
  const [images, setImages] = useState<Record<string, File>>({});
  // const [dateIssued, setDateIssued] = useState<any>(new Date(Date.now()));
  // const [targetCompletionDate, setTargetCompletionDate] = useState<any>(null);
  const [starTime, setStarTime] = useState<any>(null);
  const [finishTime, setFinishTime] = useState<any>(null);
  // const [returnVisitStartDateTime, setReturnVisitStartDateTime] =
  //   useState<any>(null);
  // const [returnVisitFinishDateTime, setReturnVisitFinishDateTime] =
  //   useState<any>(null);
  const [staffMembersRefs, setStaffMembersRefs] = useState<
    React.RefObject<SignaturePadRef>[]
  >([]);
  const [vehicle, setVehicle] = useState<any>(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [usersList, setUsersList] = useState<any[]>([]);
  const [staffMembers, setStaffMembers] = useState<any[]>([]);
  const [fileValues, setFileValues] = useState<any[]>([]);
  const [vehiclesList, setVehiclesList] = useState<any[]>([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [formValues, setFormValues] = useState<any>({
    // invoiceNo: null,
    amelioID: null,
    jobOrderNo: null,
    // invoiceValue: null,
    // dateIssued: convertDateToEpoch(new Date()),
    // targetCompletionDate: null,
    clientName: null,
    clientAddress: null,
    siteAddress: null,
    amelioStaff: [],
    date: convertDateToEpochUTC(new Date(new Date().setHours(0, 0, 0, 0))),
    startTime: null,
    finishTime: null,
    travelTime: null,
    vehicleRegistration: null,
    vehicleType: null,
    jobDescription: null,
    worksCarriedOut: null,
    // returnVisitStartDateTime: null,
    // returnVisitFinishDateTime: null,
    // remedialAction: null,
    signedDate: convertDateToEpochUTC(
      new Date(new Date().setHours(0, 0, 0, 0))
    ),
  });
  const firstRef = useRef<any>(null);

  const isDisabled = formSubmitting || isUploadInProgress;

  useEffect(() => {
    // fetchAmelioID(setFormValues, toast);
    // fetchUsersList(setUsersList, toast, setStaffMembers, setFormValues);
    // fetchVehiclesList(setVehiclesList, toast);
    fetchUsersList(
      setUsersList,
      toast,
      setStaffMembers,
      setFormValues,
      formValues,
      "add"
    );
    fetchVehiclesList(setVehiclesList, toast, formValues, setVehicle, "add");
    // Set initial load to false after first render
    setIsInitialLoad(false);
  }, []);

  const handleInputChange = (field: string, value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      [field]: value,
    }));
    // Convert date values to UTC epoch for date/time fields
    // const dateFields = [
    //   "dateIssued",
    //   "date",
    //   "startTime",
    //   "finishTime",
    //   "returnVisitStartDateTime",
    //   "returnVisitFinishDateTime",
    // ];

    // let processedValue = value;
    // if (dateFields.includes(name) && value instanceof Date) {
    //   processedValue = convertDateToEpochUTC(value);
    //   if (name === "startTime")
    //     setStarTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "finishTime")
    //     setFinishTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "returnVisitStartDateTime")
    //     setReturnVisitStartDateTime(new Date(convertDateToEpoch(value) * 1000));
    //   if (name === "returnVisitFinishDateTime")
    //     setReturnVisitFinishDateTime(
    //       new Date(convertDateToEpoch(value) * 1000)
    //     );
    // }

    // setFormValues((prev: any) => ({
    //   ...prev,
    //   [name]: processedValue,
    // }));
  };

  const [timeStampLocationValues, setTimeStampLocationValues] = useState({
    locations: [],
    timeStamps: [],
  });

  const handleTimeChange = (name: string, value: any) => {
    // Convert time values to UTC epoch for time fields
    const timeFields = [
      "startTime",
      "finishTime",
      // "dateIssued",
      "targetCompletionDate",
      "returnVisitStartDateTime",
      "returnVisitFinishDateTime",
    ];

    let processedValue = value;
    if (timeFields.includes(name) && value instanceof Date) {
      processedValue = convertDateToEpoch(value);
    }

    setFormValues((prev: any) => ({
      ...prev,
      [name]: processedValue,
    }));
  };

  const getDisplayDate = (epochValue: any): Date | null => {
    if (!epochValue) return null;
    if (epochValue instanceof Date) return epochValue;
    if (typeof epochValue === "number") {
      return new Date(epochValue * 1000);
    }
    return null;
  };

  // Function to clear all signatures
  const clearAllSignatures = useCallback(() => {
    // Don't clear signatures on initial load
    if (isInitialLoad) return;

    // Clear client signature
    if (firstRef.current) {
      firstRef.current.clear();
    }

    // Clear all staff member signatures
    staffMembersRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.clear();
      }
    });
  }, [staffMembersRefs, isInitialLoad]);

  // Update refs when additionalTeamMembers changes
  useEffect(() => {
    setStaffMembersRefs((prevRefs) => {
      // Keep existing refs
      const newRefs = [...prevRefs];
      // Add new refs if needed
      while (newRefs.length < staffMembers.length) {
        newRefs.push(React.createRef<any>());
      }
      // Remove extra refs if needed
      while (newRefs.length > staffMembers.length) {
        newRefs.pop();
      }
      return newRefs;
    });
  }, [staffMembers.length]);

  // Clear signatures when form values change
  useEffect(() => {
    clearAllSignatures();
  }, [
    // formValues?.invoiceNo,
    formValues?.amelioID,
    formValues?.jobOrderNo,
    // formValues?.invoiceValue,
    // formValues?.dateIssued,
    formValues?.targetCompletionDate,
    formValues?.clientName,
    formValues?.clientAddress,
    formValues?.siteAddress,
    formValues?.amelioStaff,
    formValues?.date,
    formValues?.startTime,
    formValues?.finishTime,
    formValues?.travelTime,
    formValues?.vehicleRegistration,
    formValues?.vehicleType,
    formValues?.jobDescription,
    formValues?.worksCarriedOut,
    formValues?.returnVisitStartDateTime,
    formValues?.returnVisitFinishDateTime,
    formValues?.remedialAction,
    clearAllSignatures,
  ]);

  // Clear signatures when photos change
  useEffect(() => {
    clearAllSignatures();
  }, [fileValues, clearAllSignatures]);

  const handleClear = (signatureRef: any) => {
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
  };

  const validateForm = () => {
    // Basic validation logic
    // if (!formValues?.invoiceNo || formValues?.invoiceNo.trim() === "") {
    //   showError("Invoice number is required", toast);
    //   return false;
    // }
    // if (!formValues?.amelioID) {
    //   showError("Amelio ID is required", toast);
    //   return false;
    // }
    // if (!formValues?.jobOrderNo || formValues?.jobOrderNo.trim() === "") {
    //   showError("Job Order No is required", toast);
    //   return false;
    // }
    // if (!formValues?.invoiceValue || formValues?.invoiceValue.trim() === "") {
    //   showError("Invoice Value is required", toast);
    //   return false;
    // }
    // if (!formValues?.dateIssued) {
    //   showError("Date Issued is required", toast);
    //   return false;
    // }
    // if (!formValues?.targetCompletionDate) {
    //   showError("Target Completion Date is required", toast);
    //   return false;
    // }
    if (!formValues?.clientName || formValues?.clientName.trim() === "") {
      showError("Client Name is required", toast);
      return false;
    }
    // if (!formValues?.clientAddress || formValues?.clientAddress.trim() === "") {
    //   showError("Client Address is required", toast);
    //   return false;
    // }
    if (!formValues?.siteAddress || formValues?.siteAddress.trim() === "") {
      showError("Site Address is required", toast);
      return false;
    }
    if (!formValues?.amelioStaff || formValues?.amelioStaff.length === 0) {
      showError("At least one Amelio Staff member is required", toast);
      return false;
    }
    if (!formValues?.date) {
      showError("Date is required", toast);
      return false;
    }
    if (!formValues?.startTime) {
      showError("Start Time is required", toast);
      return false;
    }
    if (!formValues?.finishTime) {
      showError("Finish Time is required", toast);
      return false;
    }

    // Validate that start time is not greater than finish time
    // if (formValues.startTime && formValues.finishTime) {
    //   const startTime = new Date(formValues.startTime).getTime();
    //   const finishTime = new Date(formValues.finishTime).getTime();

    //   if (startTime > finishTime) {
    //     showError("Finish Time must not be earlier than Start Time", toast);
    //     return false;
    //   }
    // }

    // if (!formValues?.travelTime || formValues?.travelTime.trim() === "") {
    //   showError("Travel Time is required", toast);
    //   return false;
    // }
    const beforePhotos = fileValues.filter(
      (photo: any) => photo.photoKey && photo.photoKey.startsWith("before")
    );
    if (beforePhotos.length === 0) {
      showError("At least one Site Before Image is required", toast);
      return false;
    }
    const afterPhotos = fileValues.filter(
      (photo: any) => photo.photoKey && photo.photoKey.startsWith("after")
    );
    if (afterPhotos.length === 0) {
      showError("At least one Site After Image is required", toast);
      return false;
    }
    // if (!formValues?.vehicleRegistration) {
    //   showError("Vehicle Registration is required", toast);
    //   return false;
    // }
    // if (!formValues?.vehicleType) {
    //   showError("Vehicle Type is required", toast);
    //   return false;
    // }
    // if (
    //   !formValues?.jobDescription ||
    //   formValues?.jobDescription.trim() === ""
    // ) {
    //   showError("Job Description is required", toast);
    //   return false;
    // }
    if (
      !formValues?.worksCarriedOut ||
      formValues?.worksCarriedOut.trim() === ""
    ) {
      showError("Works Carried Out is required", toast);
      return false;
    }
    // if (!formValues?.returnVisitStartDateTime) {
    //   showError("Return Visit Start Date/Time is required", toast);
    //   return false;
    // }
    // if (!formValues?.returnVisitFinishDateTime) {
    //   showError("Return Visit Finish Date/Time is required", toast);
    //   return false;
    // }

    // // Validate that start time is not greater than finish time
    // if (
    //   formValues.returnVisitStartDateTime &&
    //   formValues.returnVisitFinishDateTime
    // ) {
    //   const startTime = new Date(formValues.returnVisitStartDateTime).getTime();
    //   const finishTime = new Date(
    //     formValues.returnVisitFinishDateTime
    //   ).getTime();

    //   if (startTime > finishTime) {
    //     showError(
    //       "Return Visit Finish Date/Time must not be earlier than Start Date/Time",
    //       toast
    //     );
    //     return false;
    //   }
    // }

    // if (
    //   !formValues?.remedialAction ||
    //   formValues?.remedialAction.trim() === ""
    // ) {
    //   showError("Remedial Action is required", toast);
    //   return false;
    // }
    if (!firstRef.current || firstRef.current.isEmpty()) {
      showError("Client signature is required", toast);
      return false;
    }
    // Validate signatures for each staff member

    if (staffMembers.length > 0) {
      const hasEmptyAdditionalSignatures = staffMembers.some(
        (member: any, index: number) => {
          const ref = staffMembersRefs[index];
          return ref.current?.isEmpty();
        }
      );
      if (hasEmptyAdditionalSignatures) {
        showError("Signatures for all Staff Members are required", toast);
        return false;
      }
    }
    // Add your form validation logic here
    return true; // Return true if valid, false otherwise
  };

  const handleSave = async () => {
    // Logic to save the form data
    try {
      if (!validateForm()) {
        return;
      }
      setFormSubmitting(true);
      setIsUploadInProgress(true);
      // Prepare FormData
      const formData = new FormData();

      // 1. Process signatures
      const signatures: File[] = [];
      const photosArray: File[] = [];

      // Process teamMember1 signature
      if (firstRef.current && !firstRef.current.isEmpty()) {
        const signatureDataUrl = firstRef.current.toDataURL();
        const signatureFile = dataURLToFile(
          signatureDataUrl,
          `signed_client.png`
        );
        if (signatureFile) {
          signatures.push(signatureFile);
        }
      }

      // Process additional team members signatures
      staffMembers.forEach((member: any, index: number) => {
        const ref = staffMembersRefs[index];
        if (ref.current && !ref.current.isEmpty() && member.userID) {
          const signatureDataUrl = ref.current.toDataURL();
          const signatureFile = dataURLToFile(
            signatureDataUrl,
            `${member.userID}_sig.png`
          );
          if (signatureFile) {
            signatures.push(signatureFile);
          }
        }
      });

      // Add all signatures to FormData
      signatures.forEach((file, index) => {
        formData.append(`signature`, file);
      });

      fileValues.forEach((photoItem: any) => {
        if (photoItem?.photoKey && photoItem?.file) {
          const fileName = `${photoItem.photoKey}.png`;
          const dataURL = new Blob([photoItem.file], {
            type: "image/png",
          });
          const photoFile = new File([dataURL], fileName, {
            type: "image/png",
          });
          photosArray.push(photoFile);
        }
      });

      photosArray.forEach((file, index) => {
        formData.append("siteImages", file);
      });

      formData.append("formJson", JSON.stringify(formValues));
      formData.append(
        "timeStampLocationJson",
        JSON.stringify(timeStampLocationValues)
      );
      formData.append("isWeb", "true");

      const response = await axios.post(
        "health-and-safety/job-sheet-gloucester-form",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFormSubmitting(false);
      showSuccess(response.data.Message, toast);
      setIsUploadInProgress(false);
      navigate("/layout/health-and-safety/jobsheet-gloucester");
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setIsUploadInProgress(false);
      setFormSubmitting(false);
      showError(errorMessage, toast);
    }
  };

  useEffect(() => {
    if (formValues.startTime && formValues.finishTime) {
      const start = new Date(formValues.startTime * 1000);
      const finish = new Date(formValues.finishTime * 1000);

      // If finish time is less than start time, set finish date to next day
      if (
        finish.getHours() < start.getHours() ||
        (finish.getHours() === start.getHours() &&
          finish.getMinutes() < start.getMinutes())
      ) {
        const newFinish = new Date(start);
        newFinish.setDate(start.getDate() + 1);
        newFinish.setHours(finish.getHours(), finish.getMinutes(), 0, 0);
        setFinishTime(newFinish);
        setFormValues((prev: any) => ({
          ...prev,
          finishTime: Math.floor(newFinish.getTime() / 1000),
        }));
      }
    }
  }, [formValues?.startTime, formValues?.finishTime]);

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="tw-border-solid tw-border tw-border-[#E2E2e2] tw-rounded-lg tw-relative tw-bg-white ">
        <div className="tw-bg-[#F8FAFC] tw-p-4 tw-rounded-t-lg tw-border-b-[1px] tw-border-[#E2E8F0] tw-flex tw-justify-between tw-items-center">
          <h2 className="tw-text-lg sm:tw-text-xl xl:tw-text-2xl tw-font-semibold tw-text-[#101828]">
            Gloucester Job Sheet
          </h2>
        </div>
        <div>
          <div className="tw-p-4">
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-w-full tw-mb-3">
              <span className="tw-text-lg tw-font-medium ">
                Amelio Utilities Ltd.
              </span>
              <span className="tw-text-sm tw-text-[#667085]">
                5 Spinnaker Road, Gloucester
              </span>
              <span className="tw-text-sm tw-text-[#667085]">GL2 5FD.</span>
              <span className="tw-text-sm tw-text-[#667085]">
                Telephone: 01452 311991
              </span>
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" />

            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 2xl:tw-grid-cols-3 tw-gap-3 tw-w-full">
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice No</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("invoiceNo", e.target.value)
                  }
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                  // readOnly
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Amelio ID</label>
                <InputText
                  type="text"
                  value={formValues?.amelioID ?? "N/A"}
                  readOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full tw-bg-gray-50"
                />
              </div> */}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Job/order No</label>
                <InputText
                  type="text"
                  value={formValues?.jobOrderNo ?? ""}
                  onChange={(e) =>
                    handleInputChange("jobOrderNo", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Job/Order No"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Invoice Value</label>
                <InputText
                  type="text"
                  value={formValues?.invoiceValue ?? ""}
                  // value={formValues.invoiceValue}
                  onChange={(e) =>
                    handleInputChange("invoiceValue", e.target.value)
                  }
                  placeholder="Enter Invoice Value"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Date Issued</label>
                <Calendar
                  value={getDisplayDate(dateIssued)}
                  onChange={(e) => {
                    setDateIssued(e.value);
                    handleTimeChange("dateIssued", e.value);
                  }}
                  placeholder="Select Date Issued"
                  showIcon
                  showTime
                  dateFormat="dd-mm-yy"
                  hourFormat="24"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span">
                <label className="leak-label">Target Completion date</label>
                <Calendar
                  value={getDisplayDate(targetCompletionDate)}
                  // onChange={(e) =>
                  //   handleInputChange("targetCompletionDate", e.target.value)
                  // }
                  onChange={(e) => {
                    setTargetCompletionDate(e.value);
                    handleTimeChange("targetCompletionDate", e.value);
                  }}
                  placeholder="Select Target Completion Date"
                  showIcon
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px]">
              <span className="tw-font-semibold">Client Details </span>
            </Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                <label className="leak-label">
                  Client Name <span className="tw-text-red-500">*</span>
                </label>
                <InputText
                  type="text"
                  value={formValues.clientName ?? ""}
                  onChange={(e) =>
                    handleInputChange("clientName", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Client Name"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-[51px] tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                <label className="leak-label">Client Address</label>
                <InputTextarea
                  rows={1}
                  value={formValues.clientAddress ?? ""}
                  onChange={(e) =>
                    handleInputChange("clientAddress", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Client Address"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
                />
              </div>
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mb-[42px] tw-mt-[42px]">
              <span className="tw-font-semibold">Site Details </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
              <label className="leak-label">
                Site Address <span className="tw-text-red-500">*</span>
              </label>
              <InputTextarea
                rows={4}
                value={formValues.siteAddress ?? ""}
                onChange={(e) =>
                  handleInputChange("siteAddress", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Site Address"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label" htmlFor="teamMember1">
                  Amelio Staff <span className="tw-text-red-500">*</span>
                </label>
                <MultiSelect
                  value={staffMembers ?? []}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      amelioStaff: e.value.map((member: any) => ({
                        userID: member.userID,
                        displayName: member.displayName,
                      })),
                    }));
                    setStaffMembers(e.value);
                  }}
                  disabled={isDisabled}
                  maxSelectedLabels={2}
                  options={usersList}
                  optionLabel="displayName"
                  placeholder="Select Staff"
                  filter
                  className="custome-dropdown !tw-w-full tw-h-11"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Date <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(formValues.date)}
                  onChange={(e) => {
                    // Set date to UTC 12:00 AM
                    let selectedDate = e.value;
                    if (selectedDate instanceof Date) {
                      const utcDate = new Date(
                        Date.UTC(
                          selectedDate.getFullYear(),
                          selectedDate.getMonth(),
                          selectedDate.getDate(),
                          0,
                          0,
                          0,
                          0
                        )
                      );
                      handleInputChange("date", convertDateToEpoch(utcDate));
                    } else {
                      handleInputChange("date", null);
                    }
                  }}
                  disabled={isDisabled}
                  placeholder="Select Date"
                  showIcon
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Start Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(starTime)}
                  onChange={(e) => {
                    setStarTime(e.value);
                    handleTimeChange("startTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Start Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Finish Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(finishTime)}
                  onChange={(e) => {
                    setFinishTime(e.value);
                    handleTimeChange("finishTime", e.value);
                  }}
                  placeholder="Select Finish Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div> */}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Travel Time</label>
                <InputText
                  type="text"
                  value={formValues?.travelTime ?? ""}
                  onChange={(e) =>
                    handleInputChange("travelTime", e.target.value)
                  }
                  disabled={isDisabled}
                  placeholder="Enter Travel Time"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
            </div>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <PhotoUpload
                label={
                  <span>
                    Site Before Images (Max 10){" "}
                    <span className="tw-text-red-500">*</span>
                  </span>
                }
                name="before"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
                maxImages={10}
              />
              <PhotoUpload
                label={
                  <span>
                    Site After Images (Max 10){" "}
                    <span className="tw-text-red-500">*</span>
                  </span>
                }
                name="after"
                images={images}
                isUploadInProgress={isUploadInProgress}
                setIsUploadInProgress={setIsUploadInProgress}
                setImages={setImages}
                fileValues={fileValues}
                setFileValues={setFileValues}
                timeStampLocationValues={timeStampLocationValues}
                setTimeStampLocationValues={setTimeStampLocationValues}
                classname="tw-w-full"
                maxImages={10}
              />
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]">
              <span className="tw-font-semibold">Plant </span>
            </Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-3 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Vehicle Registration</label>
                <Dropdown
                  value={vehicle ?? ""}
                  onChange={(e) => {
                    setVehicle(e.value);
                    handleInputChange(
                      "vehicleRegistration",
                      e.value.registration_no
                    );
                    handleInputChange("vehicleType", e.value.vehicleType);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Vehicle Registration"
                  filter
                  options={vehiclesList}
                  optionLabel="registration_no"
                  className="custome-dropdown !tw-w-full tw-h-11"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">Vehicle Type</label>
                <InputText
                  type="text"
                  value={formValues?.vehicleType ?? ""}
                  // onChange={(e) => handleInputChange("vehicleType", e.value)}
                  readOnly
                  placeholder="Select vehicle registration for Vehicle Type"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full tw-cursor-default tw-bg-gray-50"
                />
              </div>
            </div>
            {/* <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px]" /> */}
            {/* <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2  tw-gap-3 tw-w-full tw-mt-3"> */}
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mb-[42px] tw-mt-[42px]">
              <span className="tw-font-semibold">Job Description </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span ">
              {/* <label className="leak-label">Job Description</label> */}
              <InputTextarea
                rows={4}
                value={formValues?.jobDescription ?? ""}
                onChange={(e) =>
                  handleInputChange("jobDescription", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Job Description"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px] tw-mb-[42px]">
              <span className="tw-font-semibold">
                Works Carried out <span className="tw-text-red-500">*</span>
              </span>
            </Divider>
            <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span ">
              {/* <label className="leak-label">Works Carried out</label> */}
              <InputTextarea
                rows={4}
                value={formValues?.worksCarriedOut ?? ""}
                onChange={(e) =>
                  handleInputChange("worksCarriedOut", e.target.value)
                }
                disabled={isDisabled}
                placeholder="Enter Works Carried out"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div>
            {/* </div> */}
            <Divider className="tw-my-6 tw-bg-gray-400 tw-h-[2px] tw-mt-[42px] tw-mb-[42px]"></Divider>
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              {" "}
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Finish Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(finishTime)}
                  onChange={(e) => {
                    setFinishTime(e.value);
                    handleTimeChange("finishTime", e.value);
                  }}
                  disabled={isDisabled}
                  placeholder="Select Finish Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                {/* <label className="leak-label">
                  Finish Time <span className="tw-text-red-500">*</span>
                </label>
                <Calendar
                  value={getDisplayDate(finishTime)}
                  onChange={(e) => {
                    setFinishTime(e.value);
                    handleTimeChange("finishTime", e.value);
                  }}
                  placeholder="Select Finish Time"
                  timeOnly
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                /> */}
              </div>
            </div>
            {/* <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Return visit Start date and Time
                </label>
                <Calendar
                  value={getDisplayDate(returnVisitStartDateTime)}
                  onChange={(e) => {
                    setReturnVisitStartDateTime(e.value);
                    handleTimeChange("returnVisitStartDateTime", e.value);
                  }}
                  placeholder="Select Return Visit Start Date/Time"
                  showTime
                  dateFormat="dd-mm-yy"
                  hourFormat="24"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start">
                <label className="leak-label">
                  Return Visit Finish Date and Time
                </label>
                <Calendar
                  value={getDisplayDate(returnVisitFinishDateTime)}
                  onChange={(e) => {
                    setReturnVisitFinishDateTime(e.value);
                    handleTimeChange("returnVisitFinishDateTime", e.value);
                  }}
                  placeholder="Select Return Visit Finish Date/Time"
                  showTime
                  hourFormat="24"
                  dateFormat="dd-mm-yy"
                  className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-w-full"
                />
              </div>
            </div> */}
            {/* <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-mt-3">
              <label className="leak-label">Remedial Action</label>
              <InputTextarea
                rows={4}
                value={formValues?.remedialAction ?? ""}
                onChange={(e) =>
                  handleInputChange("remedialAction", e.target.value)
                }
                placeholder="Enter Remedial Action"
                className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-w-full"
              />
            </div> */}
            <div className="tw-grid tw-grid-cols-1 xl:tw-grid-cols-2 tw-mt-3 tw-gap-3 tw-w-full">
              <div className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3">
                <div className="tw-flex tw-justify-between tw-gap-1 tw-items-center tw-w-full">
                  <span className="leak-label">
                    Client Signature <span className="tw-text-red-500">*</span>
                  </span>
                  <InputText
                    type="text"
                    className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-text-center"
                    value={getTodayDate() ?? ""}
                    readOnly
                    // disabled={isDisabled}
                  />
                </div>
                <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
                  <div className="tw-w-full">
                    <SignaturePadComponent ref={firstRef} penColor="black" />
                  </div>
                  <div className="tw-flex tw-justify-between tw-w-full tw-items-center">
                    <span className="leak-label">{formValues?.clientName}</span>
                    <Button
                      label="Clear"
                      className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-4 tw-py-1 tw-rounded-full"
                      onClick={() => handleClear(firstRef)}
                    />
                  </div>
                </div>
              </div>
              {staffMembers.map((member: any, index: number) => (
                <div
                  key={member.id || index}
                  className="tw-flex tw-flex-col tw-gap-1 tw-items-start tw-justify-start tw-col-span tw-mt-3"
                >
                  <div className="tw-flex tw-justify-between tw-gap-1 tw-items-center tw-w-full">
                    <span className="leak-label">
                      Signed (Amelio) <span className="tw-text-red-500">*</span>
                    </span>
                    <InputText
                      type="text"
                      className="tw-pl-2 tw-border tw-border-gray-300 tw-rounded-md tw-text-[#667085] tw-h-11 tw-text-center"
                      value={getTodayDate() ?? ""}
                      readOnly
                    />
                  </div>
                  <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
                    <div className="tw-w-full">
                      <SignaturePadComponent
                        ref={staffMembersRefs[index]}
                        penColor="black"
                      />
                    </div>
                    <div className="tw-flex tw-justify-between tw-w-full tw-items-center">
                      <span className="leak-label">{member.displayName}</span>
                      <Button
                        label="Clear"
                        className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-4 tw-py-1 tw-rounded-full"
                        onClick={() => {
                          handleClear(staffMembersRefs[index]);
                        }}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="tw-flex tw-justify-end tw-items-center tw-p-4  tw-gap-2 !tw-border-t-[#E2E8F0] tw-border-t-[1px]">
            <Button
              className="tw-flex tw-px-3 tw-py-2 tw-rounded focus:tw-shadow-none  !tw-border-[#C3E3F4] tw-text-[#344054] tw-font-medium"
              label="Cancel"
              color="white"
            />
            <Button
              className="tw-flex tw-px-3 focus:tw-shadow-none tw-py-2 tw-rounded tw-bg-primary tw-border-primary tw-text-white tw-font-medium"
              label={`${formSubmitting ? "Saving..." : "Save"}`}
              loading={formSubmitting}
              disabled={isDisabled}
              onClick={handleSave}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default JobsheetGloucesterForm;
